<script lang="ts">
	export let circleFill = "#bcbfc3";

</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 26.57 26">
	<g>
		<path
			d="M13 0A13 13 0 1 1 0 13 13 13 0 0 1 13 0z"
			transform="translate(.148)"
			fill={circleFill} />
		<g>
			<g>
				<path
					d="M69.788 98.728H44.276a.429.429 0 1 1 0-.834h25.512a.429.429 0 1 1 0 .834z"
					transform="translate(-43.748 -85.311)"
					style="fill:#fff" />
			</g>
		</g>
	</g>
</svg>

<style lang="scss">
</style>
